<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from 'svelte-i18n';
	import { zendureRequest } from 'src/services/zendure_reqs';
	//Stores
	//Design system components
	import { Button, Input, toast, Text } from '@Shelly/shelly-design-system';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Helpers
	import { makeNumbersPrimaryAndBold } from 'src/helpers/utilities';
	import { devices_config } from '@devices/index';
	import { real_id } from 'src/helpers/interface_helpers';

	$: settingsStore = getDeviceSettings(device.id);
	export let device;

	let settings = $settingsStore;

	$: min = devices_config?.[device?.type]?.modes?.pv?.min_charge_limits[0] || 0;
	$: max = devices_config?.[device?.type]?.modes?.pv?.min_charge_limits[1] || 100;

	// the value in status is multiplied by 10
	let minCharge: number = (settings?.minSoc || 0) / 10;
	let cache = minCharge;

	let loading = false;

	const setMinCharge = async () => {
		if (cache === minCharge) return;

		if (minCharge < min || minCharge > max) {
			return toast.open({
				type: 'danger',
				title:
					$format('movement_limit_toast', {
						values: { min: min, max: max },
					}) || 'Values must be between min - max!',
			});
		}

		let res;
		loading = true;

		res = await zendureRequest(device.id, { min_charge: minCharge * 10 });
		if (res?.isok) {
			cache = minCharge;
		}
		onSettingsResponse(res, device);

		loading = false;
	};
</script>

<Text styleType="controls-small" class="mb-s">
	{@html makeNumbersPrimaryAndBold(
		`${$format('min_charge_description', {
			default: `The device will stop discharging the battery on {value} %`,
			values: { value: minCharge },
		})}`,
	)}
</Text>

<Input
	aria-label={$format('input_set_min_charge', {
		default: 'Input set min charge',
	})}
	size="m"
	bind:value={minCharge}
	icon="fas fa-battery-bolt"
	type={'number'}
	step={1}
	{min}
	{max}
	info={$format('range_min_max_percent_value', {
		values: { min, max },
		default: 'Range: 0 % - 100 %.',
	})}
	error={minCharge < min || minCharge > max
		? $format('movement_limit_toast', {
				values: { min: min, max: max },
			}) || 'Values must be between min - max!'
		: ''}
	on:enter={setMinCharge}
	id="input-1o89a95"
/>
<Button
	class="mt-s"
	{loading}
	size="m"
	width="full"
	disabled={minCharge < min || minCharge > max}
	on:click={setMinCharge}>{$format('button_save')}</Button
>
